import { useQuery } from "react-query";
import { dashboardService } from "../api/dashboard.service";
import { IQueryOptions } from ".";

export const useGetDashboardOverview = (options?: IQueryOptions) =>
  useQuery(["dashboard", "overview"], () => dashboardService.getDashboardOverview(), {
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetDashboardStats = (options?: IQueryOptions) =>
  useQuery(["dashboard", "stats"], () => dashboardService.getDashboardStats(), {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetRecentActivities = (options?: IQueryOptions) =>
  useQuery(["dashboard", "recent-activities"], () => dashboardService.getRecentActivities(), {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetProgressChart = (options?: IQueryOptions) =>
  useQuery(["dashboard", "progress-chart"], () => dashboardService.getProgressChart(), {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
  });

export const useGetRecommendations = (options?: IQueryOptions) =>
  useQuery(["dashboard", "recommendations"], () => dashboardService.getRecommendations(), {
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 15 * 60 * 1000, // 15 minutes
    ...options,
  });
